import { addStyles } from 'ethcss'
import { grid, IStyles, mediaCSS } from '../../theme'
import { colors } from 'theme/colors'
import widgetGalleryStyles from 'pages/widgetsGallery/widgetsGallery.jcss'

const settingsStyles: IStyles = {
    version: {
        ...grid.row,
        ...grid.center,
        ...grid.mt_mini,
    },
    documentationLink: {
        ...grid.row,
    },
    documentationIcon: {
        ...grid.ml_micro,
    },
    space: {
        ...grid.space,
    },
    background: {
        background: `var(--var-module-settings-component-settingsItem-style-background, ${colors.greyLight})`,
    },
    settingsWrapper: {
        [mediaCSS.tab]: {
            paddingTop: 60,
        },
    },
    softwareLink: {
        textDecoration: 'underline',
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'none',
        },
    },
    inputWidth: {
        width: '370px',
        [mediaCSS.tab]: {
            ...grid.w100,
        },
    },
    inputWidth_L: {
        width: '410px',
        [mediaCSS.tab]: {
            ...grid.w100,
        },
    },
    greyText: {
        color: colors.greyEditor + '!important',
    },
    spanWidth: {
        maxWidth: 330,
    },

    optionWrapper: {
        marginBottom: 20,
    },
    input: {
        width: 400,

        [mediaCSS.mini]: {
            width: '100%',
        },
    },
    optionCaption: {
        marginBottom: 10,
    },
    disabled: {
        opacity: 0.5,
    },
    apiKeys: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    selectorWrapper: {
        marginBottom: 54,
        paddingTop: 24,
    },
    deleteUserDesc: {
        lineHeight: 1.2,
    },
}

addStyles(settingsStyles)
export default settingsStyles
